import React, { useState } from 'react';
import { Checkbox, IconButton, Tooltip } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { getStatusColors } from '../../../consts/AppointmentStatusColors';
import ColorPicker from './ColorPicker';
import styles from '../AppointmentStepsPage.module.css';

const MAX_NAME_LENGTH = 80;

/**
 * Nome + "Obrigatória" + cor na própria linha: serve para criar (no fim do card)
 * e para editar (no lugar da linha). Enter salva, Esc cancela. Sem cor, o card
 * da agenda segue a cor do status.
 */
function StepForm({ statusId, initialName = '', initialRequired = true, initialColor = null, busy, placeholder, onSubmit, onCancel }) {
    const [name, setName] = useState(initialName);
    const [isRequired, setIsRequired] = useState(initialRequired);
    const [color, setColor] = useState(initialColor);
    const trimmed = name.trim();

    const submit = () => {
        if (!trimmed || busy) return;
        onSubmit({ name: trimmed, isRequired, color }, (ok) => {
            // Depois de criar, o campo volta ao padrão para a próxima etapa
            if (ok && !initialName) {
                setName('');
                setIsRequired(true);
                setColor(null);
            }
        });
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            submit();
        } else if (event.key === 'Escape' && onCancel) {
            onCancel();
        }
    };

    return (
        <div className={styles.form}>
            <input
                className={styles.input}
                value={name}
                maxLength={MAX_NAME_LENGTH}
                placeholder={placeholder}
                onChange={(event) => setName(event.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus={!!initialName}
                aria-label="Nome da etapa"
            />
            <label className={styles.requiredToggle}>
                <Checkbox
                    size="small"
                    checked={isRequired}
                    onChange={(event) => setIsRequired(event.target.checked)}
                />
                <span>Obrigatória</span>
            </label>
            <ColorPicker
                label="Cor do card com esta etapa marcada"
                value={color}
                defaultColors={getStatusColors(statusId)}
                defaultLabel="Cor do status"
                disabled={busy}
                onChange={setColor}
            />
            <Tooltip title={initialName ? 'Salvar' : 'Adicionar etapa'} arrow>
                <span>
                    <IconButton
                        size="small"
                        className={styles.confirmAction}
                        onClick={submit}
                        disabled={!trimmed || busy}
                        aria-label={initialName ? 'Salvar etapa' : 'Adicionar etapa'}
                    >
                        <CheckRoundedIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            {onCancel && (
                <Tooltip title="Cancelar" arrow>
                    <IconButton size="small" className={styles.rowAction} onClick={onCancel} aria-label="Cancelar">
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </div>
    );
}

export default StepForm;
